export default "__VITE_ASSET__DXns$EGo__"